import RoleBadge from "@web/components/RoleBadge";
import type { OrgRole } from "@/types";

export default function MemberRow({
  userId,
  displayName,
  role,
  joinedAt,
  currentUserId,
  currentUserRole,
  onPromote,
  onDemote,
  onRemove,
  onTransferOwnership,
}: {
  userId: string;
  displayName: string;
  role: OrgRole;
  joinedAt: string;
  currentUserId: string;
  currentUserRole: OrgRole;
  onPromote: (userId: string) => void;
  onDemote: (userId: string) => void;
  onRemove: (userId: string, displayName: string) => void;
  onTransferOwnership: (userId: string) => void;
}) {
  const isSelf = userId === currentUserId;
  const isOwner = currentUserRole === "owner";

  return (
    <div className="bg-card rounded-[20px] p-4 shadow-[1px_1px_0px_0px_#1c1b2e] border border-[rgba(28,27,46,0.2)] flex flex-col gap-3">
      <div className="flex flex-row items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[rgba(255,45,126,0.1)] flex items-center justify-center shrink-0">
          <span className="text-aqua text-base font-extrabold">
            {displayName?.charAt(0)?.toUpperCase() ?? "?"}
          </span>
        </div>
        <div className="flex-1 flex flex-col gap-0.5">
          <span className="text-text text-sm font-bold">{displayName}</span>
        </div>
        <RoleBadge role={role} />
      </div>

      {role !== "owner" && !isSelf && isOwner && (
        <div className="flex flex-row gap-2 flex-wrap">
          {role === "admin" ? (
            <button
              type="button"
              onClick={() => onDemote(userId)}
              className="flex-1 text-center py-2 rounded-lg bg-[rgba(0,0,0,0.04)] cursor-pointer border-0 font-inherit min-w-[7rem]"
            >
              <span className="text-amber text-xs font-bold">Demote to member</span>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => onPromote(userId)}
              className="flex-1 text-center py-2 rounded-lg bg-[rgba(255,45,126,0.08)] cursor-pointer border-0 font-inherit min-w-[7rem]"
            >
              <span className="text-aqua text-xs font-bold">Promote to admin</span>
            </button>
          )}
          <button
            type="button"
            onClick={() => onRemove(userId, displayName)}
            className="flex-1 text-center py-2 rounded-lg bg-[rgba(255,59,48,0.08)] cursor-pointer border-0 font-inherit min-w-[7rem]"
          >
            <span className="text-[#cc0000] text-xs font-bold">Remove</span>
          </button>
          {isOwner && role === "admin" && (
            <button
              type="button"
              onClick={() => onTransferOwnership(userId)}
              className="flex-1 text-center py-2 rounded-lg bg-[rgba(156,77,255,0.08)] cursor-pointer border-0 font-inherit min-w-[7rem]"
            >
              <span className="text-purple text-xs font-bold">Transfer owner</span>
            </button>
          )}
        </div>
      )}

      {isSelf && (
        <div className="text-text-dim text-[0.75rem] font-bold">
          Joined {new Date(joinedAt).toLocaleDateString()}
        </div>
      )}
    </div>
  );
}
